import { useState } from "react"
import { CancelacionPreliminarGuarderia } from "../../../services/cancelacionesServicios"
import { MetodoPago } from "../../../services/ventasServicios";

export type Model = CancelacionPreliminarGuarderia & {
    metodoPagoDevolucion: MetodoPago | undefined
};

export type ValidacionCancelacion = {
    valido: boolean,
    razon: string
}

export const validarCancelacion = (model: Model): ValidacionCancelacion => {
    if(model.totalNotaCredito > model.totalAgendamiento) {
        return { valido: false, razon: 'Nota crédito no puede ser mayor al total del agendamiento' };
    }

    if(model.totalNotaCredito < 0) {
        return { valido: false, razon: 'Nota crédito no puede ser negativa' };
    }

    if(model.totalDevolucion < 0) {
        return { valido: false, razon: 'Devolución no puede ser negativa' };
    }

    return { valido: true, razon: '' };
}

export const useCancelacionPreliminar = (cancelacionInicial: CancelacionPreliminarGuarderia) => {
    const [model, setModel] = useState<Model>({ ...cancelacionInicial, metodoPagoDevolucion: undefined });
    // Formula de nuevoPendiente: 
    // pendienteVenta - totalNotaCredito + totalDevolucion

    const actualizarTotalNotaCredito = (nuevoTotalCredito: number) => {
        setModel((currModel) => ({
            ...currModel,
            totalNotaCredito: nuevoTotalCredito,
            nuevoPendiente: Math.max(0, cancelacionInicial.pendiente - nuevoTotalCredito + currModel.totalDevolucion)
        }));
    };

    const actualizarTotaDevolucion = (nuevoTotalDevolucion: number) => {
        setModel((currModel) => ({
            ...currModel,
            totalDevolucion: nuevoTotalDevolucion,
            nuevoPendiente: Math.max(0, cancelacionInicial.pendiente - currModel.totalNotaCredito + nuevoTotalDevolucion),
            metodoPagoDevolucion: nuevoTotalDevolucion > 0 ? currModel.metodoPagoDevolucion : undefined
        }));
    };

    const seleccionarMetodoPagoDevolucion = (metodo: MetodoPago) => {
        setModel((currModel) => ({
            ...currModel,
            metodoPagoDevolucion: metodo
        }));
    };

    return {
        model,
        actualizarTotalNotaCredito,
        actualizarTotaDevolucion,
        seleccionarMetodoPagoDevolucion
    };
}